import React from 'react';
import "./Card.scss";
import PropTypes from "prop-types";
const Report = ({ imgSrc, title, text, link, linkText }) => {
    return (
        <div className="cardReport">
            <div className="mainCardBox">
                <div className="cardIconSection">
                    <img src={imgSrc} className="cardIconReport" />
                </div>
                <div className="cardLabelSection">
                    <div className="cardReportTitle">{title}</div>
                    <div className="cardReportText">{text}</div>
                </div>
            </div>

            <div className="cardLinkDiv">
                <button
                    variant="text"
                    className="cardReportLink"
                    onClick={() => {
                        window.location.href = link;
                    }}
                >
                    <u>{linkText}</u>
                    <img src='navigate.png' className="navigate-icon" />
                </button>
            </div>
        </div>
    );
};

Report.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
};
// const Report = () => {
//   return (
//     <div className="cardReport">
//       <div className="mainCardBox">
//         <div className="cardIconSection">
//           <img
//             src={process.env.PUBLIC_URL + "/ic_chat.png"}
//             className="cardIconReport"
//           />
//         </div>
//         <div className="cardLabelSection">
//           <div className="cardReportTitle">
//             Issues with NetApp products or services
//           </div>
//           <div className="cardReportText">
//             A potential vulnerability with NetApp® products or services
//           </div>
//         </div>
//       </div>

//       <div className="cardLinkDiv">
//         <Button
//           variant="text"
//           className="cardReportLink"
//           onClick={() => {
//             window.location.href = "mailto:security-alert@netapp.com";
//           }}
//         >
//           <u>security-alert@netapp.com</u>
//         </Button>
//       </div>
//     </div>
//   );
// };

export default Report;
